import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import BillsPaymentTableRecords from '../BillsPaymentTableRecord';

const FailedBillsPayment = () => (
  <div className="bills-payment-root-cover"><BillsPaymentTableRecords hasNameAndImage defaultUrl={AdminRouteName.failedBillsPaymentRoute} tabStatus="failed" toggleStorageId="failed-transaction-table-col" recordPermission="can-get-bills-payment" /></div>
);
export default FailedBillsPayment;
